// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".role-breadcrumb[data-v-061dde34] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
